import { createApi } from "@reduxjs/toolkit/query/react";

import { oktaTokenBaseQuery } from "@/react/services/api";

const buildCSRUrl = (customer) => {
  if (!customer) {
    console.error("No customer provided for CSR url");
  }
  return `/v1/customers/${customer}/service-report`;
};

export const csrApi = createApi({
  reducerPath: "csr",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (build) => ({
    getCSR: build.query({
      query: (customer) => ({
        url: buildCSRUrl(customer),
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCSRQuery } = csrApi;
